import { http } from '../utils/http'

const searchAction = (params,page,size) => {
  const url = `/china/web/edi/ship/page?page=${page}&size=${size}`
  return http.post(url, params)
};
const addAction = (params) => {
  const url = `/china/web/edi/ship/add`
  return http.post(url, params)
};
const editAction = (params) => {
  const url = `/china/web/edi/ship/edit`
  return http.post(url, params)
};
export default {
  searchAction,
  addAction,
  editAction,
}
